import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=6649ffbc&lang=scss&scoped=true"
script.__scopeId = "data-v-6649ffbc"

export default script